/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="m12.146 10.7933-1.1605-1.1605c-1.1206-1.1206-1.1206-2.9374 0-4.058L15.7199.8404c1.1205-1.1205 2.9374-1.1205 4.058 0l3.3817 3.3817c1.1205 1.1206 1.1205 2.9375 0 4.058l-4.7344 4.7344c-1.1206 1.1206-2.9374 1.1206-4.058 0l-1.1605-1.1605 4.0736-4.0737a.75.75 0 0 0-1.0606-1.0606l-4.0737 4.0736ZM10.7933 12.146l-1.1605-1.1605c-1.1206-1.1206-2.9374-1.1206-4.058 0L.8404 15.7199c-1.1205 1.1205-1.1205 2.9374 0 4.058l3.3817 3.3817c1.1206 1.1205 2.9375 1.1205 4.058 0l4.7344-4.7344c1.1206-1.1206 1.1206-2.9374 0-4.058l-1.1605-1.1605-4.0737 4.0736a.75.75 0 0 1-1.0606-1.0606l4.0736-4.0737Z"
  />,
  'MenuURLsFilled'
);
